// src/shared/store/UseMissionDialogStore.ts
import { create } from 'zustand';

/**
 * 미션 성공 다이얼로그 표시 내용
 * - 화면마다 타이틀/메시지/포인트 표시 여부가 완전히 달라질 수 있어
 *   호출부에서 최종 문구(HTML 포함)를 조립해 전달한다
 */
export interface MissionDialogPayload {
  /** 다이얼로그 제목. 생략 시 컴포넌트 기본값('미션 성공!') 사용 */
  title?: string;
  /** 중간 안내 메시지. <span> 등 HTML 태그 사용 가능 */
  message: string;
  /** 획득한 별 포인트. 생략하면 포인트 안내 줄이 표시되지 않음 */
  points?: number;
  /** 상단 이미지. 생략 시 기본 starBear 이미지 사용 */
  image?: string;
  /** 확인 버튼 라벨. 생략 시 '확인' 사용 */
  confirmLabel?: string;
  /** 확인 버튼 클릭 시 다이얼로그가 닫힌 후 실행할 콜백 (여러 다이얼로그를 순차로 띄울 때 사용) */
  onConfirm?: () => void;
}

interface MissionDialogState {
  isOpen: boolean;
  payload: MissionDialogPayload | null;
  openMissionDialog: (payload: MissionDialogPayload) => void;
  closeMissionDialog: () => void;
}

/**
 * 미션 성공 다이얼로그 전역 Store
 * - 여러 화면(연속학습, 챕터/인물/시대 완료 등)에서 공통으로 사용
 */
const useMissionDialogStore = create<MissionDialogState>(set => ({
  isOpen: false,
  payload: null,

  openMissionDialog: payload => set({ isOpen: true, payload }),

  closeMissionDialog: () => set({ isOpen: false, payload: null }),
}));

export default useMissionDialogStore;
